<template>
  <div class="radio-container" :class="inline ? 'radio-container-inline' : '' ">
    <div class="radio-label">
      {{ label }} 
    </div>
    <div v-for="(option, index) in options" v-bind:key="index+option.value+option.text" class="form-check form-check-inline">
      <input
          class="form-check-input"
          type="radio"
          :name="groupName"
          :id="`radio-${id}-${index}`"
          :value="option.value"
          v-model="internalValue"
          >
      <label class="form-check-label" :for="`radio-${id}-${index}`">
        {{ option.text }} 
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioGroup",
  model: {
    prop: 'modelValue',
    event: 'modelEvent'
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    inline: Boolean,
    modelValue: [String, Boolean],
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      id: null
    }
  },
  created () {
    this.id = this._uid
  },
  methods: {

  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('modelEvent', value)
      }
    },
    groupName() {
      return `radio-${this.id}`
    }
  }
}
</script>

<style scoped>
.form-check input[type=radio] {
  margin-left: 5px;
  font-size: 16px;
}
.form-check-inline label {
  padding-left: 5px;
  padding-right: 15px;
}
.radio-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px 0;
  font-size: 16px;
  flex-grow: 1;
}

.radio-container .radio-label {
  width: 15%;
  display: inline-block;
  color: #BB86FC;
}

.radio-container-inline {
  flex-direction: row;
  align-items: center;
}
</style>